export const lastUrlSegment = (url: string, level = 1): string =>
  url.split('/').slice(-level).join('/');
